import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { getNodeIdExistsSelector } from "@skilitics/nautilus-core-designer-data";

import {
  getManifestSelector,
  getNodeAncestorIdsCreate,
  getNodeRoutePathCreate,
  getNodeSlotIdSelector,
  getNodeTypeIdSelector,
  getParentContextByIdSelector,
} from "../state/index.ts";
import type { GetNodeDesignerRouting } from "../state/selectors/getNodeRoutePath.ts";

const getNodeAncestorIdsSelector = createSelector([getNodeSlotIdSelector], (getSlotId) =>
  getNodeAncestorIdsCreate({ getSlotId }),
);

const getNodeDesignerRoutingSelector = createSelector(
  [getManifestSelector],
  (getManifest): GetNodeDesignerRouting =>
    (typeId: string) =>
      // a design can outlive the manifest for its type; no manifest is simply no route
      getManifest(typeId, { ignoreIfNotFound: true })?.designer.routing,
);

const getNodeRoutePathSelector = createSelector(
  [
    getNodeTypeIdSelector,
    getNodeAncestorIdsSelector,
    getParentContextByIdSelector,
    getNodeDesignerRoutingSelector,
    getNodeIdExistsSelector,
  ],
  (getTypeId, getAncestorIds, getParentContext, getRouting, getNodeIdExists) =>
    getNodeRoutePathCreate({ getTypeId, getAncestorIds, getParentContext, getRouting, getNodeIdExists }),
);

export const useGetNodeRoutePath = () => useSelector(getNodeRoutePathSelector);
